import React, { Fragment } from 'react';
export const setPartnerBannerLogo = (partnerLogo) => React.createElement(Fragment, null,
    "\u00A0",
    React.createElement("span", null, "with"),
    React.createElement("img", { src: partnerLogo.img, className: `partner-logo ${partnerLogo.name.toLowerCase()}`, alt: `Avalara + ${partnerLogo.name}` }));
